// import { getServerTime } from '@/api'
import { getUserDetail, getEsopUserDetail, getUserDetailWt, TicketCheck } from '@/apis/modules/uc'
import { getRunEnv } from '@/utils/env'
import { TRADE_ACCOUNT_STATUS } from '@/utils/user'
import { getQueryString, isTHSApp, isTHSI18NApp, isTHSChannel } from '@/utils/tools'
import goto, { getUrlParams } from '@/utils/goto'

// import JSBridge from '@fs/jsbridge/dist/lib/jsBridge.js'
import JSBridge from '@fs/jsbridge/dist/lib/faWealthJsBridge.js'
import { Toast } from 'vant'
import { getHKDFEncryptKey } from '@/httpRequest/encrypt'
import { THS_I18N_TICKET_KEY } from '@/httpRequest/contansts'
import { set, update } from 'lodash'
const LASTLOGIN_KEY = 'lastLogin'
const USERINFO_KEY = 'userInfo'
const ESOP_USERINFO_KEY = 'esopUserInfo'
const ESOP_LOGININFO_KEY = 'esopLoginInfo'
export const RND_KEY = 'rndKey'
const RND_KEY_2 = 'rndKey2'
export const SESSION = 'session'
const SESSION_2 = 'session2'
const UIN = 'uin'
const SUB = 'sub'
export const LOGINTIME_KEY = 'loginTime'
// 值为1已有debounce定时器，不调用接口，2没有debounce定时器，调用展期接口
export const HAS_EXTEND_PROCESS_KEY = 'hasExtendProcess'
export const HAS_EXTEND_PROCESS_VALUE = '1'
export const HAS_NO_EXTEND_PROCESS_VALUE = '2'

const userInfo = JSON.parse(localStorage.getItem(USERINFO_KEY) || '{}')
const lastLogin = JSON.parse(localStorage.getItem(LASTLOGIN_KEY) || '{}')

const esopUserInfo = JSON.parse(localStorage.getItem(ESOP_USERINFO_KEY) || '{}')
const esopLoginInfo = JSON.parse(localStorage.getItem(ESOP_LOGININFO_KEY) || '{}')

const state = () => ({
    session: localStorage.getItem(SESSION) || '',
    session2: localStorage.getItem(SESSION_2) || '',
    uin: localStorage.getItem(UIN) || '',
    rndKey: localStorage.getItem(RND_KEY) || '',
    rndKey2: localStorage.getItem(RND_KEY_2) || '',
    userInfo,
    lastLogin,

    WTtoken: '', // 从旧版网厅调过来带的 token
    WTuserName: '', // 从网厅带过来的用户名
    subAccountId: localStorage.getItem(SUB) || '', // 临时登陆账号
    showLoading: false, // 显示loading
    loadingMsg: '', // loading文案

    hlId: '',
    loginTime: Number(localStorage.getItem(LOGINTIME_KEY)) ?? 0, // 登录时间

    navTitle: '', // 顶部导航标题

    // esop
    esopToken: '', // esop token
    esopUserInfo,
    esopLoginInfo,
    isEsopProcessingToken: false, // 新增标志位
})

const getters = {
    isLogin(state) {
        return Object.keys(state.userInfo || {}).length > 0
    },
    isEsopLogin(state) {
        return Object.keys(state.esopUserInfo || {}).length > 0
    },
    isCashAccount(state) {
        return state.userInfo?.clientInfo?.accts[0]?.type === 1
    },
    isMarginAccount(state) {
        return state.userInfo?.clientInfo?.accts[0]?.type === 2
    },
    getServerTime(state) {
        return new Date().getTime() - state.localTime + state.serverTime
    },
    getWTtoken(state) {
        return state.WTtoken || localStorage.getItem('WTtoken') || ''
    },
    getEsopToken(state) {
        return state.esopToken || localStorage.getItem('esopToken') || ''
    },
    getEsopLoginInfo(state) {
        return state.esopLoginInfo || JSON.parse(localStorage.getItem(ESOP_LOGININFO_KEY) || '{}')
    },
    getWTuserName(state) {
        return state.WTuserName || localStorage.getItem('WTuserName') || ''
    },
    getSubAccountId(state) {
        return state.subAccountId || localStorage.getItem('sub')
    },
    getWTEddaWhite(state) {
        return state.WTEddaWhite || sessionStorage.getItem('WTEddaWhite') || ''
    },
    isAccountOpened(state) {
        return state.userInfo.clientStatus === TRADE_ACCOUNT_STATUS.ACCOUNT_OPENED
    },
    getUin(state) {
        return state.uin || localStorage.getItem(UIN) || ''
    },
    clientId(state) {
        return state.userInfo?.clientInfo?.accts[0]?.cltId
    },
    accountId(state) {
        return state.userInfo?.clientInfo?.accts[0]?.acctId
    },
    salt(state) {
        return state.userInfo.salt
    },
}

const mutations = {
    updateSession(state, { uin = '', rndKey = '', session = '' } = {}) {
        state.uin = uin
        state.rndKey = rndKey
        state.session = session
        localStorage.setItem(UIN, uin)
        localStorage.setItem(SESSION, session)
        localStorage.setItem(RND_KEY, rndKey)
    },
    updateSession2(state, { rndKey2 = '', session2 = '' } = {}) {
        state.rndKey2 = rndKey2
        state.session2 = session2
        localStorage.setItem(SESSION_2, session2)
        localStorage.setItem(RND_KEY_2, rndKey2)
    },
    updateUserInfo(state, userInfo) {
        state.userInfo = userInfo || {}
    },
    updateLastLogin(state, { areaCode = '+86', username = '' } = {}) {
        const lastLogin = { areaCode, username }
        localStorage.setItem(LASTLOGIN_KEY, JSON.stringify(lastLogin))
        state.lastLogin = lastLogin
    },
    updateServerTime(state, time) {
        state.serverTime = time
        state.localTime = Math.floor(new Date().getTime())
    },
    updateWTtoken(state, wtToken) {
        localStorage.setItem('WTtoken', wtToken)
        state.WTtoken = wtToken
    },
    updateEsopToken(state, esopToken) {
        console.log('🚀 ~ updateEsopToken ~ esopToken', esopToken)
        localStorage.setItem('esopToken', esopToken)
        state.esopToken = esopToken
    },
    updateEsopSession(state, esopSession) {
        localStorage.setItem('esopSession', esopSession)
        state.esopSession = esopSession
    },
    updateEsopUserInfo(state, userInfo) {
        state.esopUserInfo = userInfo || {}
        localStorage.setItem(ESOP_USERINFO_KEY, JSON.stringify(userInfo))
    },
    updateEsopLoginInfo(state, loginInfo) {
        state.esopLoginInfo = loginInfo || {}
        localStorage.setItem(ESOP_LOGININFO_KEY, JSON.stringify(loginInfo))
    },
    updateEsopProcessingToken(state, processing) {
        state.isEsopProcessingToken = processing
    },
    updateWTuserName(state, WTuserName) {
        localStorage.setItem('WTuserName', WTuserName)
        state.WTuserName = WTuserName
    },
    updateSubAccountId(state, sub) {
        localStorage.setItem(SUB, sub)
        sessionStorage.setItem(SUB, sub) // 存储在 sessionStorage 里面是为了给客服的时候使用，页面关闭自动清除，避免用错
        state.subAccountId = sub
    },
    updateHlId(state, hlId) {
        sessionStorage.setItem('hlId', hlId) // 存储在 sessionStorage 里面是为了给客服的时候使用，页面关闭自动清除，避免用错
        state.hlId = hlId
    },
    updateShowLoading(state, value) {
        // 第一个参数表示显示隐藏，第二个参数表示laoding下面的文案
        state.showLoading = value ? true : false
        state.loadingMsg = value.length ? value[1] : ''
    },
    updateUin(state, value) {
        const strUin = value + ''
        state.uin = strUin
        localStorage.setItem(UIN, strUin)
    },
    updateLoginTimeAndExtendFlag(state) {
        const time = new Date().getTime()
        state.loginTime = time
        localStorage.setItem(LOGINTIME_KEY, time)
        localStorage.setItem(HAS_EXTEND_PROCESS_KEY, HAS_NO_EXTEND_PROCESS_VALUE)
    },
}

const actions = {
    //同步app用户信息
    login({ dispatch, commit }) {
        return new Promise(resolve => {
            if (JSBridge) {
                JSBridge.login()
                    .then(async res => {
                        commit('updateSession', {
                            uin: res.uin + '',
                            rndKey: res.rndkey,
                            session: res.senssion,
                        })

                        await dispatch('getUserInfo')
                        resolve(res)
                    })
                .catch(() => {
                    JSBridge.close()
                    resolve()
                })
            } else {
                resolve()
            }
        })
    },

    // h5 登录后获取用户数据
    async getClientInfo({ commit, dispatch }, toLogin) {
        try {
            const { data } = await getUserDetail({})
            const { result } = data
            if (result) {
                commit('updateWTuserName', result.clientInfo?.accts[0]['englishName'] || '')
                commit('updateSubAccountId', result.clientInfo?.accts[0]['subAcctId'] || '')
                commit('updateHlId', result.hlId || '')
                // commit('updateWTEddaWhite', '1')
                dispatch('setUserInfo', result)
            } else {
                commit('updateWTuserName', '')
                commit('updateSubAccountId', '')
                commit('updateHlId', '')
                dispatch('setUserInfo', {})
                if (toLogin) {
                    dispatch('toLogin')
                }
            }
        } catch (e) {
            console.log('getClientInfo error', e)
        }
    },
    async getUserInfoInWT({ commit, dispatch }) {
        const subAccountId = getQueryString('sub', true) || localStorage.getItem('sub')
        try {
            const { data = {} } = (await getUserDetailWt(subAccountId)) || {}
            const result = data.result || {}
            commit('updateWTuserName', result?.chineseName || '')
            commit('updateSubAccountId', result.subAcctId || subAccountId)
            // commit('updateAccts', result || {})
            commit('updateUin', result?.uin)
            const userInfo = { ...result, clientStatus: 31 /* 证券账户已经开通 */, clientInfo: { accts: [{ ...result }] } }
            dispatch('setUserInfo', userInfo)
        } catch (e) {
            dispatch('logout')
        }
    },
    async getEsopUserInfo({ commit, dispatch }) {
        try {
            const { data = {} } = (await getEsopUserDetail()) || {}
            const result = data.result || {}
            dispatch('setEsopUserInfo', result)
        } catch (e) {
            dispatch('logoutEsop')
        }
    },
    // 登录失效跳转登录页
    async toLogin({ dispatch }, callbackPath = '') {
        if (getRunEnv() == 1 && JSBridge) {
            // app未登录跳转登录页
            await dispatch('login')
        }
        if (getRunEnv() == 3) {
            // H5 未登录跳转登录页，使用 goto 统一处理
            const query = {
                path: decodeURIComponent(location.href),
                ...getUrlParams(),
            }
            const langType = getQueryString('langType')
            if (langType) query.langType = langType
            if (callbackPath) {
                goto(callbackPath, { query })
            } else {
                goto('login', { query })
            }
        }
    },

    setUserInfo({ commit }, userInfo) {
        if (userInfo) {
            localStorage.setItem(USERINFO_KEY, JSON.stringify(userInfo))
        } else {
            localStorage.removeItem(USERINFO_KEY)
        }
        commit('updateUserInfo', userInfo)
    },
    setEsopUserInfo({ commit }, userInfo) {
        if (userInfo) {
            localStorage.setItem(ESOP_USERINFO_KEY, JSON.stringify(userInfo))
        } else {
            localStorage.removeItem(ESOP_USERINFO_KEY)
        }
        commit('updateEsopUserInfo', userInfo)
    },

    setEsopLoginInfo({ commit }, loginInfo) {
        if (loginInfo) {
            localStorage.setItem(ESOP_LOGININFO_KEY, JSON.stringify(loginInfo))
        } else {
            localStorage.removeItem(ESOP_LOGININFO_KEY)
        }
        commit('updateEsopLoginInfo', loginInfo)
    },

    getUserInfo({ dispatch, commit }, toLogin = true, refresh = false) {
        return new Promise(resolve => {
            if (JSBridge) {
                JSBridge.getUserinfo({ refresh })
                    .then(res => {
                        commit('updateSession', {
                            uin: res.uin + '',
                            rndKey: res.rndkey,
                            session: res.session,
                        })
                        commit('updateWTuserName', res.clientInfo?.accts?.[0]['englishName'] || '')
                        commit('updateSubAccountId', res.clientInfo?.accts?.[0]['subAcctId'] || '')
                        commit('updateHlId', res.hlId || '')
                        // commit('updateWTEddaWhite', '1')
                        dispatch('setUserInfo', res)
                        resolve(res)
                    })
                    .catch(() => {
                        dispatch('clearUserInfo')
                        if (toLogin) {
                            dispatch('login').then(res => {
                                resolve(res)
                            })
                        } else {
                            resolve()
                        }
                    })
            } else {
                resolve()
            }
        })
    },
    async getUserInfoAllStack({ dispatch }, options = false) {
        let toLogin = false
        let opts = {}
        if (typeof options === 'boolean') {
            toLogin = options
            opts.toLogin = options
        } else {
            toLogin = options.toLogin
            opts = { ...options }
        }

        if (JSBridge) {
            await dispatch('getUserInfoWithOptions', opts)
        } else if (getRunEnv() === 3 || isTHSI18NApp() || isTHSApp()) {
            // 站外H5
            await dispatch('getClientInfo', toLogin)
        } else if (getRunEnv() === 2) {
            // 网厅
            await dispatch('getUserInfoInWT', toLogin)
        }
    },
    // 传参版本
    getUserInfoWithOptions({ dispatch, commit }, options = {}) {
        return new Promise(resolve => {
            if (JSBridge) {
                const { toLogin = true, ...params } = options

                JSBridge.getUserinfo(params)
                    .then(res => {
                        commit('updateSession', {
                            uin: res.uin + '',
                            rndKey: res.rndkey,
                            session: res.session,
                        })
                        commit('updateWTuserName', res.clientInfo?.accts?.[0]['englishName'] || '')
                        commit('updateSubAccountId', res.clientInfo?.accts?.[0]['subAcctId'] || '')
                        commit('updateHlId', res.hlId || '')
                        // commit('updateWTEddaWhite', '1')
                        dispatch('setUserInfo', res)
                        resolve(res)
                    })
                    .catch(() => {
                        dispatch('clearUserInfo')
                        if (toLogin) {
                            dispatch('login').then(res => {
                                resolve(res)
                            })
                        } else {
                            resolve()
                        }
                    })
            } else {
                resolve()
            }
        })
    },

    async checkI18nThsAuthorization({ dispatch }) {
        console.log('ths i18n before get userinfo, run here every time')
        if (isTHSChannel()) {
            const ticket = getQueryString('ticket') || localStorage.getItem(THS_I18N_TICKET_KEY)
            try {
                // 生成rndKey供ticketCheck接口解密使用，接口请求成功后使用后端返回的数据覆盖rndKey，只有此接口需要额外设置rndKey
                const key = await getHKDFEncryptKey(ticket)
                localStorage.setItem('rndKey', key)
                // 将ticket保存本地，兼容同html跳转路由没有携带ticket参数校验异常
                localStorage.setItem(THS_I18N_TICKET_KEY, ticket)
                const res = await TicketCheck({ ticket })
                dispatch('setSession', res?.data?.result)
                dispatch('setSession2', res?.data?.result)
                console.log('this is THSI18NApp&THSApp ticketCheck decrypt result:', res?.data?.result)
                return Promise.resolve()
            } catch {
                if (isTHSI18NApp()) {
                    Toast('同花顺国际版授权失败')
                } else {
                    Toast('同花顺授权失败')
                }
                return Promise.resolve()
            }
        }
        return Promise.resolve()
    },

    logout({ dispatch }) {
        dispatch('clearUserInfo')
        dispatch('getUserInfo')
    },

    logoutEsop({ dispatch }) {
        // dispatch('clearEsopUserInfo')
        // dispatch('getEsopUserInfo')
    },

    // 清空用户数据
    clearUserInfo({ dispatch, commit }) {
        commit('updateSession')
        dispatch('setUserInfo', null)
        localStorage.removeItem(SESSION)
        localStorage.removeItem(UIN)
        localStorage.removeItem(SUB)
        localStorage.removeItem(RND_KEY)
        localStorage.removeItem(LOGINTIME_KEY)
        localStorage.removeItem(HAS_EXTEND_PROCESS_KEY)
    },

    clearEsopUserInfo({ dispatch, commit }) {
        commit('updateEsopSession')
        dispatch('setEsopUserInfo', null)
        dispatch('setEsopLoginInfo', null)
        localStorage.removeItem(SESSION)
        localStorage.removeItem(UIN)
        localStorage.removeItem(SUB)
        localStorage.removeItem(RND_KEY)
        localStorage.removeItem(LOGINTIME_KEY)
        localStorage.removeItem(HAS_EXTEND_PROCESS_KEY)
        localStorage.removeItem('esopToken')
    },

    setWTToken({ commit }, wtToken) {
        commit('updateWTtoken', wtToken)
    },
    setEsopToken({ commit }, esopToken) {
        commit('updateEsopToken', esopToken)
    },
    setWTuserName({ commit }, WTuserName) {
        commit('updateWTuserName', WTuserName)
    },
    setSubAccountId({ commit }, sub) {
        commit('updateSubAccountId', sub)
    },
    setSession({ commit }, res) {
        commit('updateSession', {
            uin: res.uin + '',
            rndKey: res.rndkey,
            session: res.session,
        })
    },
    setEsopSession({ commit }, res) {
        commit('updateSession', {
            uin: res.uin + '',
            rndKey: res.rndkey,
            session: res.sessionEsop,
        })
    },
    setSession2({ commit }, res) {
        commit('updateSession2', {
            rndKey2: res.rndkey2,
            session2: res.session2,
        })
    },
    setLoginTimeAndExtendSessionFlag({ commit }) {
        commit('updateLoginTimeAndExtendFlag')
    },
    setEsopProcessingToken({ commit }, processing) {
        commit('updateEsopProcessingToken', processing)
    },
}

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions,
}
